"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var lodash_1 = require("lodash");
(0, rxjs_1.fromEvent)(window, "DOMContentLoaded", { once: true }).subscribe(function () {
    // const haveToTrackClick = (e: Event)
    var clicks$ = (0, rxjs_1.fromEvent)(document.body, "click").pipe((0, operators_1.filter)(function (e) { return e.type === "click"; }), (0, operators_1.map)(function (e) {
        var $el = e.target;
        return ($el === null || $el === void 0 ? void 0 : $el.hasAttribute("data-track"))
            ? $el
            : $el === null || $el === void 0 ? void 0 : $el.closest("[data-track]");
    }), (0, operators_1.filter)(function (e) { return !!e; }), (0, operators_1.map)(function ($el) {
        var trackingsEvent = $el.getAttributeNames();
        var mappedAttributes = trackingsEvent.reduce(function (acc, name) {
            var _a;
            var isClickEvent = name === null || name === void 0 ? void 0 : name.startsWith("data-track-click");
            if (!isClickEvent)
                return __assign({}, acc);
            var formattedName = name === null || name === void 0 ? void 0 : name.replace("data-track-click", "");
            var nameToCamelCase = (0, lodash_1.camelCase)(formattedName);
            return __assign(__assign({}, acc), (_a = {}, _a[nameToCamelCase] = $el.getAttribute(name), _a));
        }, {});
        return __assign({ action: "click" }, mappedAttributes);
    }));
    clicks$.subscribe(function (trackings) { return window.dataLayer.push(trackings); });
});
